import { Spoiler, Text } from "@mantine/core";

export function ClampableText(props: { text: string | undefined; contractAt?: number }) {
    const limit = props.contractAt || 150;

    if (!props.text) {
        return null;
    }

    if (props.text.length <= limit) {
        return <Text size="sm">{props.text}</Text>;
    }

    return (
        <Spoiler hideLabel="Visa mindre" maxHeight={72} showLabel="Läs mer">
            <Text size="sm">{props.text}</Text>
        </Spoiler>
    );
}
